import { translateI18n } from '~/common/utils/i18n-helper';
/* 通用常量、变量 */

/** 【订单域模块配置】
 ** moduleName 模块英文名，多用于详情页在获取数据、点击跳转时，判断来源于哪个模块
 ** pageName 模块中文名
 ** detailName 模块详情页名，用于打开详情页时唤起对应的详情组件
 ** objectType 实体类型，对应后端的表名，用于详情页底部公共页签传参，如附件、消息、备注、活动
 ** authRoute 模块对应的鉴权路由
 **/
export const orderModuleConfig = {
  buyCar: {
    moduleName: 'buyCar',
    pageName: translateI18n('portal.mai-ru-che'),
    detailName: 'BuyCarDetail',
    objectType: 'to_be_done',
    authRoute: '/store/order/buy_car'
  },
  sellCar: {
    moduleName: 'sellCar',
    pageName: translateI18n('portal.mai-chu-che'),
    detailName: 'SellCarDetail',
    objectType: 'to_be_done',
    authRoute: '/store/order/sell_car'
  },
  paymentFlow: {
    moduleName: 'paymentFlow',
    pageName: translateI18n('portal.zhi-fu'),
    detailName: 'PaymentFlowDetail',
    objectType: 'commerce_order_payment',
    authRoute: '/store/order/payment_flow'
  },
  saleBill: {
    moduleName: 'saleBill',
    pageName: translateI18n('portal.xiao-shou-gen-dan'),
    detailName: 'SaleBillDetail',
    objectType: 'commerce_order',
    authRoute: '/store/order/sale_bill'
  },
  saleItem: {
    moduleName: 'saleItem',
    pageName: translateI18n('portal.xiao-shou-gen-xiang'),
    detailName: 'SaleItemDetail',
    objectType: 'commerce_line_item',
    authRoute: '/store/order/sale_item'
  },
  saleReturn: {
    moduleName: 'saleReturn',
    pageName: translateI18n('portal.xiao-shou-tui-huo'),
    detailName: 'SaleReturnDetail',
    objectType: 'commerce_order_return',
    authRoute: '/store/order/sale_return'
  },
  purchaseBill: {
    moduleName: 'purchaseBill',
    pageName: translateI18n('portal.cai-gou-gen-dan'),
    detailName: 'PurchaseBillDetail',
    objectType: 'commerce_order',
    authRoute: '/store/order/purchase_bill'
  },
  purchaseItem: {
    moduleName: 'purchaseItem',
    pageName: translateI18n('portal.cai-gou-gen-xiang'),
    detailName: 'PurchaseItemDetail',
    objectType: 'commerce_line_item',
    authRoute: '/store/order/purchase_item'
  },
  purchaseReturn: {
    moduleName: 'purchaseReturn',
    pageName: translateI18n('portal.cai-gou-tui-huo'),
    detailName: 'PurchaseReturnDetail',
    objectType: 'commerce_order_return',
    authRoute: '/store/order/purchase_return'
  },
  arbitration: {
    moduleName: 'arbitration',
    pageName: translateI18n('portal.zhong-cai'),
    detailName: 'ArbitrationDetail',
    objectType: 'to_be_done',
    authRoute: '/store/order/arbitration'
  },
  customerOrder: {
    moduleName: 'customerOrder',
    pageName: translateI18n('portal.ke-hu-xia-dan-ren'),
    detailName: 'CustomerOrderDetail',
    objectType: 'to_be_done',
    authRoute: '/store/order/customer_order'
  },
  providerOrder: {
    moduleName: 'providerOrder',
    pageName: translateI18n('portal.gong-fang-xia-dan-ren'),
    detailName: 'ProviderOrderDetail',
    objectType: 'to_be_done',
    authRoute: '/store/order/provider_order'
  }
};

// 通用阶段
export const commonStatus = [{
  id: 'L',
  name: translateI18n('portal.chu-shi')
}, {
  id: 'E',
  name: translateI18n('portal.lian-xi')
}, {
  id: 'A',
  name: translateI18n('portal.jiao-fu')
}, {
  id: 'D',
  name: translateI18n('portal.wan-cheng')
}];

// 审批状态
export const approvedStatusList = [{
  id: 'P',
  name: translateI18n('portal.chu-shi')
}, {
  id: 'S',
  name: translateI18n('portal.ti-jiao')
}, {
  id: 'A',
  name: translateI18n('portal.pi-zhun')
}, {
  id: 'R',
  name: translateI18n('portal.tui-hui')
}, {
  id: 'C',
  name: translateI18n('portal.che-hui')
}];

// 详情页基础信息初始化字段
export const initDetailFields = {
  edit: false,
  isEdit: false,
  isAdd: false,
  showAll: false,
  showLogo: true,
  showBanner: true,
  moreBtn: false,
  labelWidth: 105,
  maxLabelWidth: 105,
  disabled: true
};

// 详情页抽屉的初始化数据
export const defaultShowDetailInfo = {
  moduleName: '',
  // 详情页所属的模块英文名
  detailName: '',
  // 详情页对应的组件名
  objectId: '',
  // 实体id，即表格行的主键id，也是详情页的主键id
  objectType: '',
  // 实体类型，即该模块对应的后台表名
  rowData: {},
  // 表格行数据
  drawerLevel: 1 // 抽屉层级
};

// 详情页底部页签的初始化传值配置
export const defaultTabPropData = {
  moduleName: '',
  // 详情页所属的模块英文名
  objectId: '',
  // 实体id，即表格行的主键id，也是详情页的主键id
  rowData: {},
  // 表格行数据
  detailData: {} // 详情数据
};

// 详情页底部4个固定页签的通用配置项
export const detailFixedTabData = {
  tabNav: [{
    id: 'Attachment',
    name: translateI18n('portal.fu-jian')
  }, {
    id: 'Message',
    name: translateI18n('portal.xiao-xi')
  }, {
    id: 'Note',
    name: translateI18n('portal.bei-zhu')
  }, {
    id: 'Activity',
    name: translateI18n('portal.huo-dong')
  }],
  tabMain: {
    Attachment: {
      type: 'table'
    },
    Message: {
      type: 'text'
    },
    Note: {
      type: 'text'
    },
    Activity: {
      type: 'table'
    }
  }
};

// 表格翻页默认值。方便表格翻页复用
export const defaultPageData = {
  current: 1,
  pageSizes: [10, 20, 50, 100, 200],
  page_size: 50,
  total: 0,
  layout: 'total, sizes, prev, pager, next, jumper',
  background: true
};

// 表格排序默认值。默认按更新时间，降序排列
export const defaultTableOrder = 'updated_at descending';

// 税种类型
export const taxList = [{
  id: 'V',
  name: translateI18n('portal.zeng-zhi-shui')
}, {
  id: 'S',
  name: translateI18n('portal.xiao-gui-mo')
}, {
  id: 'N',
  name: translateI18n('portal.hai-wai')
}];

// 订单信息
export const orderInfo = [{
  id: 'order_number',
  name: translateI18n('portal.ding-dan-hao'),
  value: ''
}, {
  id: 'shop_name',
  name: translateI18n('portal.shang-hu'),
  value: ''
}, {
  id: 'shop_member_name',
  name: translateI18n('portal.jiao-yi-yuan'),
  value: ''
}, {
  id: 'account_owner_name',
  name: translateI18n('portal.yong-jin-dai-biao'),
  value: ''
}, {
  id: 'is_combined',
  name: translateI18n('portal.huo-yun'),
  value: ''
}, {
  id: 'shipping_remarks',
  name: translateI18n('portal.bu-chong-bei-zhu'),
  value: ''
}];

// 订单条款
export const orderItem = [[{
  id: 'shipping_info',
  name: translateI18n('portal.shou-huo-fang'),
  value: ''
}], [{
  id: 'shipping_term',
  name: translateI18n('portal.huo-yun-tiao-jian'),
  value: ''
}, {
  id: 'shipping_method',
  name: translateI18n('portal.huo-yun-fang-shi'),
  value: ''
}], [{
  id: 'tax_info',
  name: translateI18n('portal.fu-kuan-fang'),
  value: ''
}], [{
  id: 'payment_term',
  name: translateI18n('portal.fu-kuan-tiao-jian'),
  value: ''
}, {
  id: 'payment_method',
  name: translateI18n('portal.fu-kuan-fang-shi'),
  value: ''
}], [{
  id: 'bank_info',
  name: translateI18n('portal.shou-kuan-fang'),
  value: ''
}], [{
  id: 'account_payment_term_invoice',
  name: translateI18n('portal.kai-piao-tiao-jian'),
  value: ''
}, {
  id: 'invoice_warn_msg',
  name: translateI18n('portal.kai-piao-fang-shi'),
  value: ''
}]];

// 激活与归档
export const isActiveList = [{
  id: true,
  name: 'O'
}, {
  id: false,
  name: 'C'
}];

// 订单总计
export const orderSum = [{
  id: 'line_item_count',
  name: translateI18n('portal.xiang-shu'),
  value: ''
}, {
  id: 'currency',
  name: translateI18n('portal.bi-zhong'),
  value: ''
}, {
  id: 'tax_rate',
  name: translateI18n('portal.shui-l'),
  value: ''
},
//在区域接口数据拿tax_rate
{
  id: 'subtotal',
  name: translateI18n('portal.wei-shui-zong-ji'),
  value: ''
},
//subtotal = total - tax_total
{
  id: 'tax_total',
  name: translateI18n('portal.shui-e'),
  value: ''
}, {
  id: 'total',
  name: translateI18n('portal.han-shui-zong-ji'),
  value: ''
}];

// 通用型布尔数组
export const commonBoolean = [{
  id: true,
  value: true,
  label: translateI18n('portal.shi'),
  name: translateI18n('portal.shi')
}, {
  id: false,
  value: false,
  label: translateI18n('portal.fou'),
  name: translateI18n('portal.fou')
}];

// 买卖类型
export const businessTypeList = [{
  id: 'M',
  name: translateI18n('portal.pi-pei')
}, {
  id: 'L',
  name: translateI18n('portal.mu-lu')
}, {
  id: 'A',
  name: translateI18n('portal.cuo-he')
}, {
  id: 'Q',
  name: translateI18n('portal.te-jia')
}];

// 默认条款
export const defaultClauseList = [{
  id: 'TVM',
  name: 'TVM'
}, {
  id: 'CVY',
  name: 'CVY'
}, {
  id: 'TSM',
  name: 'TSM'
}];

// 支付状态
export const paymentStatusList = [{
  id: 'not_paid',
  name: translateI18n('portal.wei-zhi-fu')
}, {
  id: 'awaiting',
  name: translateI18n('portal.deng-dai-zhi-fu')
}, {
  id: 'captured',
  name: translateI18n('portal.yi-zhi-fu')
}, {
  id: 'partially_refunded',
  name: translateI18n('portal.bu-fen-tui-kuan')
}, {
  id: 'refunded',
  name: translateI18n('portal.yi-tui-kuan')
}, {
  id: 'canceled',
  name: translateI18n('portal.yi-qu-xiao')
}];

// 交易方式
export const tradeMethodList = [{
  id: 'platform',
  name: translateI18n('portal.ping-tai')
}, {
  id: 'self-operated',
  name: translateI18n('portal.nei-lian')
}, {
  id: 'offline',
  name: translateI18n('portal.wai-lian')
}
// { id: 'online', name: '线上' },
// { id: 'service', name: '服务' },
];

// 交易方式不同对应的账户类型
export const tradeAccountTypeList = {
  platform: 'shop',
  offline: 'business',
  online: '' // 线上的todo
};

// 交易类型
export const tradeTypeList = [{
  id: true,
  name: translateI18n('portal.shou-ru')
}, {
  id: false,
  name: translateI18n('portal.zhi-chu')
}];

// 履约状态
export const fulfillmentStatusList = [{
  id: 'not_fulfilled',
  name: translateI18n('portal.weilyue')
}, {
  id: 'partially_fulfilled',
  name: translateI18n('portal.bu-fenlyue')
}, {
  id: 'fulfilled',
  name: translateI18n('portal.yilyue')
}, {
  id: 'partially_shipped',
  name: translateI18n('portal.bu-fenlyue')
}, {
  id: 'shipped',
  name: translateI18n('portal.yilyue')
}, {
  id: 'requires_action',
  name: translateI18n('portal.weilyue')
}, {
  id: 'partially_returned',
  name: translateI18n('portal.bu-fen-tui-huo')
}, {
  id: 'returned',
  name: translateI18n('portal.yi-tui-huo')
}, {
  id: 'canceled',
  name: translateI18n('portal.yi-qu-xiao')
}];

// 货运（配套）
export const combinedList = [{
  id: true,
  name: translateI18n('portal.dao-qi-zai-fa')
}, {
  id: false,
  name: translateI18n('portal.sui-dao-sui-fa')
}];

// 货运方式
export const shippingMethodList = [{
  id: '100',
  name: translateI18n('portal.lu-yun')
}, {
  id: '200',
  name: translateI18n('portal.hai-yun')
}, {
  id: '300',
  name: translateI18n('portal.kong-yun')
}];

// 付款条件
export const paymentTermList = [{
  id: 'TT',
  name: 'TT'
}, {
  id: 'COD',
  name: 'COD'
}, {
  id: 'NET',
  name: 'NET'
}];

// 退货类型（id 为后端取值，name 为 i18n key）
export const returnTypeList = [{
  id: 'normal',
  name: 'portal.zheng-chang-tui-huo'
}, {
  id: 'virtual',
  name: 'portal.xu-ni-tui-huo'
}, {
  id: 'supplier',
  name: 'portal.tui-gong-ying-shang'
}];

// 货运条件唯一
export const shippingTermList = [{
  id: translateI18n('portal.shi'),
  name: translateI18n('portal.shi')
}, {
  id: translateI18n('portal.fou'),
  name: translateI18n('portal.fou')
}];

// 货运条件
// export const shippingTermListOne = [
//   { id: '是', name: '是' },
//   { id: '否', name: '否' },
//   { id: '自己付', name:'是'},
//   { id: '对方付', name:'否'},
// ];

// export const shippingTermListTwo = [
//   { id: '是', name: '是' },
//   { id: '否', name: '否' },
//   { id: '自己付', name:'否'},
//   { id: '对方付', name:'是'},
// ];

// 开票条件
export const invoiceTermList = [{
  id: '1',
  name: translateI18n('portal.xian-piao-hou-kuan')
}, {
  id: '2',
  name: translateI18n('portal.xian-kuan-hou-piao')
}];

// 开票方式
export const invoiceWarnMsgList = [{
  id: 'electronic',
  name: translateI18n('portal.dian-zi-fa-piao')
}, {
  id: 'paper',
  name: translateI18n('portal.zhi-zhi-fa-piao')
}];

// 付款方式
export const paymentMethodList = [{
  id: translateI18n('portal.zhuan-zhang'),
  name: translateI18n('portal.zhuan-zhang')
}, {
  id: translateI18n('portal.xian-jin'),
  name: translateI18n('portal.xian-jin')
}, {
  id: translateI18n('portal.yin-hang-hui-piao'),
  name: translateI18n('portal.yin-hang-hui-piao')
}, {
  id: translateI18n('portal.dian-hui'),
  name: translateI18n('portal.dian-hui')
}, {
  id: translateI18n('portal.xin-yong-ka'),
  name: translateI18n('portal.xin-yong-ka')
}, {
  id: translateI18n('portal.qi-ta'),
  name: translateI18n('portal.qi-ta')
}];

// 启用状态
export const activeList = [{
  id: true,
  name: translateI18n('portal.qi-yong-y')
}, {
  id: false,
  name: translateI18n('portal.qi-yong-n')
}];

// 售前变更类型
export const beforeChangeTypeList = [{
  id: 'item_update',
  name: translateI18n('portal.gai-shu-liang')
}, {
  id: 'item_remove',
  name: translateI18n('portal.che-xiang')
}];

// 售前变更审批意见
export const approveTypeList = [{
  id: 'approve',
  name: translateI18n('portal.pi-zhun')
}, {
  id: 'return',
  name: translateI18n('portal.tui-hui')
}];

// 支付收银台-线下转账信息
export const offlinePayeeInfo = [{
  id: translateI18n('portal.yin-hang-hu-ming'),
  name: translateI18n('portal.xin-zhi-yuan-gong-ying-lian-guan-li-shen-zhen-you-xian-gong-si')
}, {
  id: translateI18n('portal.yin-hang-zhang-hao'),
  name: '44250100002900003236'
}, {
  id: translateI18n('portal.kai-hu-yin-hang'),
  name: translateI18n('portal.jian-she-yin-hang-shen-zhen-bao-an-lu-zhi-hang')
}];

// 引起订单进入提交(S)状态的原因
export const orderApproveFor = {
  edit: 'edit',
  // 订单编辑并提交了
  cancel: 'cancel',
  // 订单触发取消接口
  item_edit: 'item_edit' // 订单的某个子项变更了
};

// 支付凭证默认配置（目前复用钱包那套配置）
export const defaultPaymentVoucher = {
  params: null,
  entityCode: 'trade_record',
  filename: translateI18n('portal.zhi-fu-liu-shui-ping-zheng'),
  showPrintBtn: false
};
export const waitInvoicing = [{
  id: 'all',
  name: translateI18n('portal.quan-bu')
}, {
  id: 'waiting',
  name: translateI18n('portal.dai-shen-qing')
}, {
  id: 'completed',
  name: translateI18n('portal.yi-shen-qing')
}, {
  id: 'no_required',
  name: translateI18n('portal.wu-xu-shen-qing')
}];
export const waitInvoicingT = [{
  id: 'all',
  name: translateI18n('portal.quan-bu')
}, {
  id: 'waiting',
  name: translateI18n('portal.dai-shen-qing')
}, {
  id: 'completed',
  name: translateI18n('portal.yi-shen-qing')
}, {
  id: 'no_required',
  name: translateI18n('portal.wu-xu-shen-qing')
}];
export const getGood = [{
  id: 'unreceived',
  name: translateI18n('portal.dai-shou-huo')
}, {
  id: 'received',
  name: translateI18n('portal.yi-shou-huo')
}];
export const orderStatus = [{
  id: 'waiting_pay',
  name: translateI18n('portal.dai-zhi-fu')
}, {
  id: 'processing_pay',
  name: translateI18n('portal.zhi-fu-zhong')
}, {
  id: 'group_buying',
  name: translateI18n('portal.pin-tuan-zhong')
}, {
  id: 'waiting_shipped',
  name: translateI18n('portal.dailyue')
}, {
  id: 'part_shipped',
  name: translateI18n('portal.bu-fenlyue')
}, {
  id: 'shipped',
  name: translateI18n('portal.yilyue')
}, {
  id: 'canceled',
  name: translateI18n('portal.yi-qu-xiao')
}, {
  id: 'wait_approve',
  name: translateI18n('portal.dai-que-ren')
}];
export const delivery = [{
  id: '0',
  name: translateI18n('portal.wei-pei-shou')
}, {
  id: '1',
  name: translateI18n('portal.bu-fen-pei-shou')
}, {
  id: '2',
  name: translateI18n('portal.yi-pei-shou')
}];
export const deliveryT = [{
  id: '0',
  name: translateI18n('portal.wei-pei-song')
}, {
  id: '1',
  name: translateI18n('portal.bu-fen-pei-song')
}, {
  id: '2',
  name: translateI18n('portal.yi-pei-song')
}];
export const categoryList = [{
  id: '10',
  name: translateI18n('portal.shi-wu')
}, {
  id: '20',
  name: translateI18n('portal.fu-wu')
}, {
  id: '30',
  name: translateI18n('portal.shu-zi')
}, {
  id: '40',
  name: translateI18n('portal.zhong-chou')
}, {
  id: '50',
  name: translateI18n('portal.pei-e')
}];
